/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import cloneDeep from 'lodash/cloneDeep';

import { Input } from '@atoms';

import s from './styles.module.less';

const AdditionColoursInputs = ({ gridColumns = 1, disabled, value: inputs = [], onChange }) => {
  const handleInputChange = (event, inputId) => {
    const inputValue = event.target.value;
    const _inputs = cloneDeep(inputs);
    const newInputs = _inputs.map((input) => {
      if (input.id === inputId) {
        input.value = inputValue;
        return input;
      }
      return input;
    });

    onChange(newInputs);
  };

  // we need a space after 1fr to make it work
  const columnsCount = `1fr `.repeat(gridColumns).trim();

  return (
    <Input.Group className={s.inputsWrapper} style={{ gridTemplateColumns: columnsCount }}>
      {inputs.map((input) => (
        <div className={s.inputWrapper}>
          <Input
            key={input.id}
            className={s.input}
            value={input.value}
            onChange={(event) => handleInputChange(event, input.id)}
            disabled={disabled}
          />
          {/* // TODO: add the ability to display the color icon in the <Input /> component */}
          <div style={{ backgroundColor: input.value }} className={s.colorPreview} />
        </div>
      ))}
    </Input.Group>
  );
};

export default AdditionColoursInputs;
